export default __webpack_public_path__ + "static/media/thumb-IVTS-1.2fd64d5f.png";